export const normalizeObject = (mapping, data) => {
    const payload = {};
    Object.keys(data).forEach((item) => {
        payload[mapping[item]] = data[item];
    });
    return payload;
};
